import React from 'react';
import styles from './Q_MyCapsulePlaceholder.module.css';
import A_Tag from '@/components/A_Atoms/A_Tag/A_Tag';

interface Q_MyCapsulePlaceholderProps {
  type?: 'image' | 'video' | 'gif' | 'link' | 'audio' | 'text' | 'empty';
  label?: string;
}

export default function Q_MyCapsulePlaceholder({
  type = 'empty',
  label,
}: Q_MyCapsulePlaceholderProps) {
  const getPlaceholderLabel = (): string => {
    if (label) return label;

    switch (type) {
      case 'link':
        return 'LINK';
      case 'video':
        return 'MP4';
      case 'gif':
        return 'GIF';
      case 'audio':
        return 'MP3';
      case 'text':
        return 'TXT';
      case 'image':
        return 'IMG';
      default:
        return '';
    }
  };

  const placeholderLabel = getPlaceholderLabel();

  return (
    <div className={styles.wrapper}>
      {placeholderLabel && <A_Tag label={placeholderLabel} />}
    </div>
  );
}
